import axios from 'axios';

// const urlApi = (window as any).globalConfig.URL_API
//   ? (window as any).globalConfig.URL_API
//   : '';

const api_load = axios.create({
  baseURL: `${process.env.REACT_APP_CONECTOGO_URL_API}${process.env.REACT_APP_CONECTOGO_URL_API_LOAD_PATH}`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000,
});

export default api_load;
